import { Component, Input, ViewChild } from '@angular/core';
import { CampanhaFilter } from '../../filter';
import { CampanhaROIChartComponent } from '../../charts/roi';

@Component({
    selector: 'sgt-campanha-dashboard',
    templateUrl: './campanha-dashboard.component.html',
    styleUrls: ['campanha-dashboard.component.less']
})
export class CampanhaDashboardComponent {
    @Input() filter: CampanhaFilter;

    // ROI por Campanha
    @ViewChild('roiChart') roiChart: CampanhaROIChartComponent;

    load() {
        // ROI por Campanha
        this.roiChart?.load(this.filter);
    }
}
